import React, { useState } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios';
// import { Toast } from 'primereact/toast';
import useUserRole from '../hooks/useUserRole';
import { Dialog } from 'primereact/dialog';
import useAppRoot from '../hooks/useAppRoot';

const PaymentButton = ({ quotation }) => {
    // const toast = useRef(null);
    const role = useUserRole();
    const [visible, setVisible] = useState(false);
    const [payingStatus, setPayingStatus] = useState(false);
    const appRoot = useAppRoot();

    const onClose = () => {
        setVisible(false);
    };

    const pay = (payment) => {
        setPayingStatus(true);

        if (payment === 'flow') {
            axios
                .put('/quotations/' + quotation.id_registro + '/paymentLink')
                .then((response) => {
                    // window.open(response.data.link, '_blank');
                    window.location.href = response.data.link;
                })
                .catch(() => {
                    // toast.current.clear();
                    // toast.current.show({ severity: 'error', detail: 'Ha ocurrido un error interno. Intente nuevamente.' });
                })
                .finally(() => {
                    setPayingStatus(false);
                });
        } else {
            setVisible(true);
            setPayingStatus(false);
        }
    };

    if (quotation.precio > 350 && role === 2 && quotation.estado != 'Pagado') {
        return (
            <>
                <Dialog visible={visible} onHide={onClose} header="Datos Bancarios" modal>
                    <div className="p-4">
                        <div className="mb-2">
                            <strong>Banco:</strong> BCI
                        </div>
                        <div className="mb-2">
                            <strong>Nombre del Titular:</strong> Farmacann Spa
                        </div>
                        <div className="mb-2">
                            <strong>RUT:</strong> 77.054.137-9
                        </div>
                        <div className="mb-2">
                            <strong>Email:</strong> contacto@narma.cl
                        </div>
                        <div className="mb-2">
                            <strong>Tipo de Cuenta:</strong> Corriente
                        </div>
                        <div className="mb-2">
                            <strong>Número de Cuenta:</strong> 63336421
                        </div>
                        <div className="alert alert-info mt-4">La producción se iniciará en cuanto recibamos el comprobante de pago.</div>
                    </div>
                </Dialog>

                <div className="mt-4 row">
                    <div className="col-12 col-lg-2" />
                    <div className="col-12 col-lg-8">
                        <div className="row">
                            <div className="col-12 col-md-6 d-flex justify-content-center align-items-center order-1">
                                <div>
                                    <img src={`${appRoot}/images/logo-flow.svg`} alt="Flow" style={{ width: '150px' }} />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mt-4 mt-md-0 d-flex justify-content-center align-items-center order-3 order-md-2 mt">
                                <div>
                                    <img src={`${appRoot}/images/logo-transferencia.png`} alt="Transferencia" style={{ height: '60px' }} />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mt-2 order-2 order-md-3">
                                <Button
                                    label="Pagar en línea"
                                    className="text-nowrap w-100"
                                    severity="secondary"
                                    loading={payingStatus}
                                    onClick={() => pay('flow')}
                                />
                            </div>
                            <div className="col-12 col-md-6 mt-2 order-4">
                                <Button
                                    label="Transferencia Bancaria"
                                    className="text-nowrap w-100"
                                    severity="secondary"
                                    onClick={() => pay('transferencia')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-2" />
                </div>
            </>
        );
    }

    return null;
};

export default PaymentButton;
